import styled from "styled-components";
import { GoToSpinBgImg, MiniSpin } from '@assets'

export const RootContainer = styled.div`
  height: 74px;
  background-color: #DEEDFF;
  background-image: url(${GoToSpinBgImg});
  background-position: center;
  background-size: 100% 100%;
  border-radius: 24px;
  margin-top: 16px;

  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`

export const Spin = styled(MiniSpin)`
  margin-left: 24px;
  width: 50px;
  height: 50px;

  @media screen and (max-width: 370px) {
    margin-left: 16px;
  }
`

export const SpinTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex: 1;
  margin-left: 10%;
  margin-right: 5px;
  @media screen and (max-width: 370px) {
    margin-left: 7%;
  }

`

export const FirstText = styled.p`
  display: block;
  color: #000;
  /* font-size: 15px; */
  font-size: ${props => props.burmese === 'true' ? '12px' : "15px"};
  font-style: normal;
  font-weight: 400;
  line-height: normal;

  @media screen and (max-width: 420px) {
    font-size: ${props => props.burmese === 'true' ? '11px' : "14px"};
  }

  @media screen and (max-width: 375px) {
    font-size: ${props => props.burmese === 'true' ? '10px' : "13px"};
  }

  @media screen and (max-width: 345px) {
    font-size: ${props => props.burmese === 'true' ? '9px' : "12px"};
  }
`

export const SecText = styled.p`
  display: block;
  color: #013EAA;
  font-size: ${props => props.burmese === 'true' ? '13px' : "15px"};
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  
  @media screen and (max-width: 420px) {
    font-size: ${props => props.burmese === 'true' ? '11px' : "14px"};
  }

  @media screen and (max-width: 375px) {
    font-size: ${props => props.burmese === 'true' ? '10px' : "13px"};
  }

  @media screen and (max-width: 345px) {
    font-size: ${props => props.burmese === 'true' ? '9px' : "12px"};
  }
`

export const Button = styled.button`
  margin-right: 24px;
  border-radius: 18px;
  background:  linear-gradient(90deg, #0060BE 0%, #04AEED 100%);
  border: none;
  padding: 2px 10px;

  color: #FFF;
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: 21px; 

  @media screen and (max-width: 370px) {
    margin-right: 16px;
  }
`